export default {
  setEntity (state, payload) {
    state.id = payload.id
    state.name = payload.name
    state.email = payload.email
    state.permission = payload.permission
    state.apiToken = payload.apiToken
    state.avatar = payload.avatar
    state.username = payload.username
    state.telegram = payload.telegram
    state.mqttToken = payload.mqttToken
    state.apps = payload.apps
    state.childs = payload.childs
    state.container = payload.container
    state.userType = payload.__typename
  },

  clearEntity (state) {
    state.id = null
    state.name = ''
    state.email = ''
    state.username = ''
    state.permission = {}
    state.token = {}
    state.isDeveloper = false
    state.avatar = null
    state.telegram = {}
    state.mqttToken = null
    state.apps = []
    state.childs = []
    state.container = {}
    state.userType = ''
  }
}